<template>
    <div class="dialog-container">
        <el-dialog
            v-model="dialogVisible"
            :width="width"
            :title="title"
            align-center
            lock-scroll
            :close-on-click-modal="false"
            v-bind="$attrs"
        >
            <slot name="context"></slot>
            <template v-if="showFooter" #footer>
                <div class="dialog-footer">
                    <slot name="footer"></slot>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script lang="ts" setup>
import {computed} from 'vue';

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    width: {
        type: String,
        default: '550px'
    },
    title: {
        type: String,
        default: ''
    },
    showFooter: {
        type: Boolean,
        default: true
    }
});
const emits = defineEmits(['update:modelValue']);
const dialogVisible = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emits('update:modelValue', val);
    }
});
</script>
<style lang="scss" scoped>
//弹窗背景模糊效果
.dialog-container :deep(.el-overlay) {
    height: 100vh;
    background: rgba(255, 255, 255, 0.5) !important;
    backdrop-filter: blur(15px);
    .el-overlay-dialog {
        background: none;
    }
}

.dialog-container :deep(.el-dialog) {
    border-radius: 12px;
    .el-dialog__title {
        font-size: 15px;
        color: #303133;
        font-weight: 600;
    }
    .el-dialog__header {
        padding: 24px 60px;
        margin-right: 0;
    }
    // 关闭按钮
    .el-dialog__headerbtn {
        top: 24px;
        right: 60px;
        width: 24px;
        height: 24px;
        background: #f5f7f9;
        border-radius: 4px;
        cursor: pointer;
        .el-dialog__close {
            color: #c6c9cd;
            font-size: 20px;
            vertical-align: middle;
        }
    }
    .el-dialog__body {
        padding: 0 60px 10px 60px;
    }
    .el-dialog__footer {
        padding: 24px 60px;
        border-top: 1px solid #f5f7f9;
    }
}

// footer样式
.dialog-container .dialog-footer {
    width: 100%;
    display: flex;
    justify-content: end;
    gap: 10px;
    // border-top: 1px solid #F5F7F9;
}
</style>
<style lang="scss">
.el-overlay.is-message-box {
    height: 100vh;
    background: rgba(255, 255, 255, 0.5) !important;
    backdrop-filter: blur(15px);
    .el-overlay-dialog {
        background: none;
    }
    .el-message-box {
        border-radius: 8px;
        padding: 30px 40px 24px;
        .el-message-box__content {
            padding: 0 0 36px 0;
        }
        .el-message-box__btns {
            padding: 0;
            button {
                padding: 6px 30px;
                border-radius: 8px;
                border: 1px solid #dfe2ee;
                &.el-button--primary {
                    // background: linear-gradient(275deg, #2388FF 31.6%, #00A3FF 96.64%);
                }
                &:nth-child(2) {
                    margin-left: 20px;
                }
            }
        }
    }
}
</style>
